export default __webpack_public_path__ + "static/media/2.ee102d5b.jpg";